import { ProgressEvent } from '../../../adapters';
import { ContentDuration, MediaControllerState, PlanetMediaPlayer, PlaybackSessionState } from '../../../media-player';
import { MediaItem } from '../../../models';
import { ScriptLoader } from '../../../utils';
import { VideoAnalyticsTrackerType } from './enums';
import { IShinyStatVideoAnalyticsObject, ShinyStatTrackerOptions } from './models';
import { PlaybackSessionTracker } from './playback-session-tracker';

export class ShinyStatTracker extends PlaybackSessionTracker<VideoAnalyticsTrackerType.ShinyStat, ShinyStatTrackerOptions> {

    private scriptLoader: ScriptLoader;
    protected videoAnalytics: IShinyStatVideoAnalyticsObject;

    constructor() {
        super();
        this.scriptLoader = new ScriptLoader();
    }

    async setup(player: PlanetMediaPlayer, options: ShinyStatTrackerOptions): Promise<ShinyStatTracker> {
        await super.setup(player, options);
        this.options = options;
        if (!window['codeVAReady']) {
            const account: string = options?.account;
            const url: string = '//codicefl.shinystat.com/cgi-bin/getserver.cgi?USER=' + account + '&CODE=101&RND=123';
            await this.scriptLoader.require(url);
        }
        this.videoAnalytics = (new window['videoAnalytics']() as IShinyStatVideoAnalyticsObject);
        return this;
    }

    trackContentLoad(item: MediaItem, index: number): void {
        this.reset();
        this.videoAnalytics.loadVideoAnalytics(
            this.options.account,
            item.mediaid || '',
            document.location.href,
            item.title || item.description,
            this.options.category || '0',
            '', 0,
        );
    }

    trackPlaybackStart(position: number, duration: ContentDuration): void {
        let d: number = duration.value;
        if (duration.isInfinity || !!duration) {
            d = 24 * 60 * 60;
        }
        // videojs returns the duration as seconds
        d = d * 1000;
        this.videoAnalytics.start(d);
    }

    trackPlaybackPause(position: number, duration: ContentDuration): void {
        this.videoAnalytics.stop();
    }

    trackSeek(position: number): void {
        this.videoAnalytics.setCurrentTime(position);
    }

    onUserInteraction(data): void {
        // no-op
        // shiny-stat non traccia questo evento.
    }

    trackPlaybackComplete(): void {
    }

    reset(): void {
        this.videoAnalytics.stop();
        this.videoAnalytics.resetPlugin();
    }

    dispose(): void {
        // no-op
    }

    onError(error: Error): void {
        // noop - track playback stop automatically
    }

    onSetupError(setupError: Error): void {
        // noop - the player never started playback
    }

    trackPlaybackResume(position: number, duration: ContentDuration): void {
    }

    trackSessionEnd(session: PlaybackSessionState): void {
    }

    trackSessionCreate(session: PlaybackSessionState): void {
    }

    trackStateChange(oldState: MediaControllerState, newState: MediaControllerState): void {
        // no-op
    }

    onBufferChange(data: ProgressEvent): void {
    }
}
